const statuses = [
    {'value': 'revoked', 'label': 'Revoked', 'variation': 'negative'},
    {'value': 'active', 'label': 'Active', 'variation': 'positive'},
]

export default statuses
